exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#document-activity-dialog textarea{overflow-y:hidden !important;resize:none !important}#document-activity-form{width:680px}#document-activity-dialog .checkbox input[type=\"checkbox\"]{margin-top:2px}\n", ""]);

